import React from "react";
import styled from "styled-components";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 25px;
    width: 100%;

    svg {
        width: 114px;
        height: 114px;
        margin-bottom: 14px;
        color: #34d399;
    }
`;

const Alert = styled.h4`
    font-weight: 500;
    font-size: 24px;
    color: #000000;
    margin-bottom: 11px;
`;

const DataContainer = styled.div`
    background: #ecfdf5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 28px;
    max-width: 367px;

    p {
        color: #565656;
        font-weight: 500;
        font-size: 14px;
    }

    h2 {
        font-weight: 600;
        font-size: 40px;
        color: #000000;
    }

    h3 {
        font-weight: 600;
        font-size: 18px;
        color: #000000;
    }

    h4 {
        font-weight: 400;
        font-size: 16px;
        color: #000000;
    }
`;

function CreateLocationSuccess({ locationData }) {
    return (
        <Container>
            <CheckCircleIcon />
            <Alert>Location is added successfully</Alert>

            <DataContainer>
                <p>Auto generated code</p>
                <h2>{locationData?.autoGeneratedCode}</h2>
            </DataContainer>

            <DataContainer>
                <p>Auto generated name</p>
                <h3>{locationData?.nameAr}</h3>
                <h4>
                    {locationData?.cityName} - {locationData?.governorateName}
                </h4>
                <h4>{locationData?.locationCategoryName}</h4>
            </DataContainer>
        </Container>
    );
}

export default CreateLocationSuccess;
